import { BaseButton, Row, SizedBox } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import { C4Text } from "../text/CustomText";
import { Theme } from "../../Theme";

function PrimaryButton({ icon, text, onClick, width = "auto", padding, disabled = false, onlyIcon = false }) {
    return (
        <BaseButton
            width={width}
            padding={padding ?? (icon ? "8.5px 10px" : "10px 10px")}
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"8px"}
            backgroundColor={disabled ? Theme.color.gray400 : Theme.color.indigo500}
            onClick={onClick}
            hoverBackgroundColor={disabled ? Theme.color.gray400 : Theme.color.indigo700}
        >
            <Row alignItem={"center"} cursor={"pointer"}>
                {icon && (
                    <>
                        <CustomIcon iconName={icon} size={"17px"} cursor={"pointer"} />
                        {!onlyIcon && <SizedBox width={"7px"} />}
                    </>
                )}
                <C4Text fontColor={Theme.color.white}>{text}</C4Text>
            </Row>
        </BaseButton>
    );
}

export default PrimaryButton;
